export const TRANSACTION_TYPES = [
  { type: 'SP', label: 'Shopping with Pro Rewards at Home Depot' },
  { type: 'JC', label: 'Job Spend' },
  { type: 'JR', label: 'Job Refund' },
  { type: 'EX', label: 'Points Expired' },
  { type: 'UK', label: 'Unknown' },
  { type: 'RF', label: 'Friend Referral ' },
  { type: 'PB,BP', label: 'Points Bonus' },
  { type: 'PA', label: 'Pro Rewards Points Adjustment ' },
  { type: 'SB', label: 'Signup Bonus' },
  { type: 'SV', label: 'Survey Bonus Points' },
];
